import "./ReplaceArticle.scss";
import "./ReplaceListItemsSubstitutes.scss";

import React from "react";
import { FormattedMessage } from "react-intl";
import { trackReplaceSearchLink, trackReplaceSearchLinkClose } from "shared/src/tracking/ListTrackingUtil";

import { SearchResultArticle } from "../SearchResultArticle";

import { Modal } from "react-bootstrap";

import ReplaceListItem from "./ReplaceListItem";

import { PageType } from "shared/src/types/PageType";
import { SubstitutesStore } from "../../../../../stores/substitutes/SubstitutesStore";
import { LoadState } from "../../../../../stores/utils/RequestStateContainer";
import Spinner from "../../../../general/Spinner";
import { ReplaceModalFooter } from "./ReplaceModalFooter";
import { ReplacementKindDana } from "shared/src/tracking/Tracking";
import { SearchResultRenderData } from "shared/src/types/RenderData";

export type ReplaceInfo = {
    oldVariantId: string;
    oldBundleId: string | undefined | null;
    bettyBundleId: string | undefined | null;
    listId: string | undefined | null;
    close: () => void;
};

type ItemProps = {
    bettyVariantId: string;
    bundleId: string;
    listId: string | undefined | null;
    onClose: () => void;
    onToggle: () => void;
    show: boolean;
    artName: string | undefined | null;
    listOfArticles: Array<any>;
    pageType: any;
    children: any;
    data: Array<SearchResultRenderData>;
    loadState: LoadState;
};

/**
 * Similar to ReplaceListItem, but uses dana recommendations instead of a simple search.
 */
class ReplaceListItemSubstitutes extends React.Component<ItemProps, {}> {
    static Trigger: typeof ReplaceListItemSubstitutesModalTrigger;

    renderBody = () => {
        switch (this.props.loadState) {
            case "INITIAL":
            case "LOADING":
                return <Spinner />;
            case "FAILED":
                return null;
        }
        const replace: ReplaceInfo = {
            oldVariantId: this.props.bettyVariantId,
            oldBundleId: this.props.bundleId,
            bettyBundleId: this.props.bundleId,
            listId: this.props.listId,
            close: this.props.onClose
        };

        if (this.props.data === undefined || this.props.data === null || this.props.data.length === 0) {
            return (
                <div className="replace-dialog-no-result">
                    <FormattedMessage id={"EX_REPLACE_DANA_NO_RESULT"} />
                </div>
            );
        }

        return (
            <React.Fragment>
                {this.props.data.map((oneArticle: SearchResultRenderData) => {
                    return (
                        <SearchResultArticle
                            item={oneArticle}
                            query={oneArticle.name}
                            listOfArticles={[]}
                            onList
                            pageType="SHOPPING_LIST"
                            recentlyOrdered={false}
                            deprecated={false}
                            inContainer={false}
                            searchResultLayout="LIST"
                            replace={replace}
                            replacementKind={ReplacementKindDana}
                        />
                    );
                })}
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                bsSize="large"
                dialogClassName="ex-replace-article-modal mfcss"
                animation
                keyboard
                onHide={this.props.onClose}
                show={this.props.show}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <FormattedMessage id="EX_REPLACE_DANA" />
                        {' "'}
                        {this.props.artName}
                        {'"'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="ex-confirm-modal">
                    {this.renderBody()}
                    <ReplaceModalFooter onClick={this.props.onToggle} onClickI18nKey="EX_REPLACE_TOGGLE_TO_SEARCH" />
                </Modal.Body>
            </Modal>
        );
    }
}

type Props = {
    bettyVariantId: string | undefined | null;
    bundleId: string | undefined | null;
    listId: string | undefined | null;
    artName: string | undefined | null;
    listOfArticles: Array<any> | undefined | null;
    children?: any;
    pageType: PageType;
    asButton: boolean;
};

class ReplaceListItemSubstitutesModalTrigger extends React.Component<
    Props,
    {
        showModal: boolean;
    }
> {
    state = { showModal: false };

    close = () => {
        this.setState({ showModal: false });
        trackReplaceSearchLinkClose(this.props.bundleId, ReplacementKindDana);
    };

    open = (event: React.SyntheticEvent<unknown>) => {
        event.preventDefault();
        this.setState({ showModal: true });
        trackReplaceSearchLink(this.props.bundleId, ReplacementKindDana);
        // Initial search for the article.
        if (this.props.bettyVariantId) {
            SubstitutesStore.update(this.props.bettyVariantId);
        }
    };

    render() {
        let modal;
        if (this.state.showModal) {
            modal = <ReplaceListItem {...this.props} show={this.state.showModal} onClose={this.close} />;
        }
        const asButtonClassName = this.props.asButton ? " replace-as-button" : "";
        return (
            <span className={"ex-replace-articles" + asButtonClassName}>
                <a onClick={this.open}>{this.props.children}</a>
                {this.state.showModal && modal}
            </span>
        );
    }
}

ReplaceListItemSubstitutes.Trigger = ReplaceListItemSubstitutesModalTrigger;

export default ReplaceListItemSubstitutes;
export { ReplaceListItemSubstitutesModalTrigger as Trigger };
